<div class="Integrations container d-flex flex-column m-auto p-5" *ngIf="componentReady">
  <div class="Integrations__title d-flex justify-content-center">
    <p>Retreva&reg; offers synchronization of contacts from {{userSession.integration.name}}.</p>
  </div>
  <div class="Integrations__body d-flex mt-3 flex-column">
    <div class="Integrations__body__row mb-3 row" *ngFor="let field of fields">
      <div class="Integrations__body__row__label col col-12 col-md-6">
        <p>{{integrationData.fields[field].label}}</p>
      </div>
      <div class="Integrations__body__row__control col col-12 col-md-6" [formGroup]="formGroup">
        <ng-container [ngSwitch]="integrationData.fields[field].control">
          <ng-container *ngSwitchCase="'text'">
            <app-text-field [placeholder]="integrationData.fields[field].label" [formControlName]="field"></app-text-field>
          </ng-container>
          <ng-container *ngSwitchCase="'list'">
            <app-select [label]="integrationData.fields[field].label" [items]="getDynamicList(integrationData.fields[field].control_source)" [formControlName]="field"></app-select>
          </ng-container>
          <ng-container *ngSwitchCase="'checkbox'">
            <mat-checkbox [formControlName]="field"></mat-checkbox>
          </ng-container>
        </ng-container>
      </div>
    </div>
    <div class="Integrations__footer row">
      <div class="col col-12 col-md-6 offset-md-6">
        <app-button [text]="submitButtonProperties.text" [color]="submitButtonProperties.color" [size]="submitButtonProperties.size" [Click]="submitButtonProperties.onClick" [observeApi]="true"></app-button>
      </div>
    </div>
  </div>
</div>
